<ch-navigation></ch-navigation>

<ch-hotkey-cheatsheet></ch-hotkey-cheatsheet>

<ch-error></ch-error>

<ch-toasts></ch-toasts>

<router-outlet></router-outlet>

<ng-template ngbModalContainer></ng-template>
